<template>
  <div class="row d-flex flex-column align-center py-5">
    <h4 class="text-center fw-bold mb-4">{{ $t("registerContents.labels.register") }}</h4>
    <div class="col-lg-6 d-flex flex-column align-center" style="position: relative; z-index: 1;">
      <v-card v-if="registerbox" class="register-card" style="border-radius:7px;box-shadow: 0px 0px 8px 0px black;" outlined>
        <div class="row d-flex align-items-center justify-content-center">
          <div class="col-md-12 main-page">
            <div class="bg-light main-page mx-auto shadow-none"
              style="background-color:#f8b2b2; width: 100%; height: auto;">
              <!-- <div class="col-12 pe-1 pt-1 d-flex justify-end" @click="closeRegisterBox()">
                <v-icon size="small" style="color:navy; cursor:pointer">mdi-close-circle</v-icon>
              </div> -->

              <div v-if="regForm" style="width: 90%;">
                <v-form ref="form" class="py-3 form-data m-auto" v-model="valid" @submit.prevent="submitForm">
                  <div class="row">
                    <div class="col-md-4">
                      <v-text-field v-model="personal.firstname" :rules="firstnameRules" :label="this.$t('flightInfoContent.labels.firstName')" variant="underlined"
                      placeholder="Enter First Name" style="height: 60px;"></v-text-field>
                      <!-- <span style="color: red;">invalid Username</span><br> -->
                    </div>
                    <div class="col-md-4">
                      <v-text-field v-model="personal.middlename" :label="this.$t('flightInfoContent.labels.middleName')" variant="underlined"
                      placeholder="Enter Middle Name" style="height: 60px;"></v-text-field>
                      <!-- <span style="color: red;">invalid Username</span><br> -->
                    </div>
                    <div class="col-md-4">
                      <v-text-field v-model="personal.lastname" :rules="lastnameRules" :label="this.$t('flightInfoContent.labels.lastName')" variant="underlined"
                      placeholder="Enter Last Name" style="height: 60px;"></v-text-field>
                      <!-- <span style="color: red;">invalid Username</span><br> -->
                    </div>
  
                    <div class="col-md-6">
                      <v-text-field v-model="personal.email" :rules="eMail" :label="this.$t('registerContents.labels.emailId')" placeholder="johndoe@gmail.com"
                        type="email" variant="underlined" style="height: 60px;"></v-text-field>
                      <!-- <span style="color: red;">invalid Email</span><br> -->
                    </div>

                    <div class="col-md-6">
                      <v-text-field v-model="personal.phonenumber" :rules="phoneRules" :label="this.$t('flightInfoContent.labels.phoneNumber')" 
                      minlength="5" maxlength="15" @keypress="filter(event)" variant="underlined" style="height: 60px;"></v-text-field>
                      <!-- <span style="color: red;">invalid Email</span><br> -->
                    </div>
                    
                    <div class="col-md-6">
                      <v-text-field v-model="personal.password" :rules="passWord" :label="this.$t('registerContents.labels.password')"
                        placeholder="Enter your password" variant="underlined" required
                        :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'" :type="visible ? 'text' : 'password'"
                        @click:append-inner="visible = !visible" style="height: 60px;"></v-text-field>
                      <!-- <span style="color: red;">invalid password</span> -->
                    </div>
  
                    <div class="col-md-6">
                      <v-text-field v-model="personal.rePassword" :rules="repassWord" :label="this.$t('registerContents.labels.confirmPassword')"
                        placeholder="Enter your Confirm password" variant="underlined" required
                        :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'" :type="visible ? 'text' : 'password'"
                        @click:append-inner="visible = !visible" style="height: 60px;"></v-text-field>
                      <!-- <span style="color: red;">invalid Re-password</span> -->
                    </div>
                  </div>

                  <div class="d-flex my-4">
                    <div class="col-9 d-flex justify-end">
                      <v-btn width="70%" :disabled="btnDisabled" type="submit"
                        style="background-color:#94C20E; color:white">{{ $t("registerContents.buttonsLink.submit")}}</v-btn>
                    </div>
                    <div class="col-3 ps-3 d-flex justify-end">
                      <v-progress-circular v-if="loadRegister" :width="3" style="color:navy"
                        indeterminate></v-progress-circular>
                    </div>
                  </div>
                  <!-- <v-divider></v-divider> -->
                  <div>
                    <p class="text-center" style="font-weight: 600;">{{ $t("registerContents.buttonsLink.alreadyAccount")}}
                      <span style="cursor: pointer;"> &nbsp;
                        <!-- <b style="color:navy"></b> -->
                        <a href="/login" style="color:navy;text-decoration:none;text-align:end;font-weight:600;">{{ $t("registerContents.buttonsLink.login")}}</a>
                      </span>
                    </p>
                    <p class="mb-0 text-end"><a href="/">Return to home</a></p>
                  </div>
                </v-form>
              </div>


              <div v-if="regMsg">
                <div class="d-flex justify-center align-center p-3">
                  <v-icon color="success" size="50">mdi-check-circle-outline</v-icon>
                  <h4 class="text-success ps-2 m-0"> {{ $t("registerContents.successNotify.text2")}}...</h4>
                </div>
                <div class="d-flex justify-center align-center p-3">
                  <p class="m-0">{{ registerMsg }}</p>
                </div>
                <div class="d-flex w-100 px-2 mb-2">
                  <v-btn text="Return To Home" to="/" height="25px" class="text-capitalize text-white mx-auto" color="#94c20e"></v-btn>
                  <!-- <v-btn text="Login" to="/login" height="25px" class="text-capitalize text-white" color="#94c20e"></v-btn> -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>

  <!-- <div v-if="loginSection">
    <loginCom></loginCom>
  </div> -->
  <div class="text-center" v-if="dataloader">
    <dataloader></dataloader>
  </div>
</template>

<script>
// import loginCom from '@/components/loginCom.vue';
import axios from 'axios';
import dataloader from "@/components/dataLoder.vue";
import { getConfigDataFromLocalStorage } from '@/localStorageData/localStorageUtil.js';

export default {
  components: {
    // loginCom
        dataloader,
  },
  data() {
    return {
      dataloader: true,
      valid: false,

      registerbox: true,
      loginSection: true,
      terms: false,
      visible: false,

      regForm: true,
      regMsg: false,
      registerMsg: "",
      loadRegister: false,
      btnDisabled: false,

      personal: {
        firstname: "",
        middlename: "",
        lastname: "",
        email: "",
        phonenumber: "",
        password: "",
        rePassword: ""
      },

      firstnameRules: [
        v => !!v || 'Please enter first name',
        v => (v.length >= 3) || 'Name must be greater than 3 ',
      ],
      lastnameRules: [
        v => !!v || 'Please enter last name',
      ],
      // middlenameRules: [
      //   v => !!v || 'Please enter first name',
      //   v => (v.length >= 3) || 'Name must be greater than 3 ',
      // ],

      eMail: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],

      // phoneRules: [
      //   (v) => !!v || "Phone Number is required",
      //   (v) => /^\+?\d{5,15}$/.test(v) || "Invalid Phone Number",
      // ],

      passWord: [
        v => !!v || 'Please enter password',
        // v => (v && v.length >= 8) || 'Password must be at least 8 characters',
        // v => (v && v.length <= 20) || 'Password must be less than 20 characters',
        // v => (v && /[a-z]/.test(v)) || 'Password must contain at least one lowercase letter',
        // v => (v && /[!@#$%^&*]/.test(v)) || 'Password must contain at least one special character'
      ],
      repassWord: [
        v => !!v || 'Please enter confirm password',
        v => v === this.personal.password || 'Passwords do not match'
      ],

      // registerReq: {
      //   "request_type": "user_register",
      //   "user_name": "",
      //   "email": "",
      //   "password": "",
      //   "portal_id": "",
      //   "portal_group_id": "",
      //   "portal_domain":"",
      //   "user_id": "",
      //   "token": "Tc7RQaX79Hrx5CFK"
      // },

      registerReq: {
        "request_type": "user_register",
        "user_name":"",
        "first_name":"",
        "middle_name":"",
        "last_name":"",
        "email": "",
        "phone_no": "",
        "password": "",
        "portal_id": "",
        "portal_group_id": "",
        "portal_domain":"",
        "user_id": "",
        "token": "Tc7RQaX79Hrx5CFK"
      },

      registerUrl:"",
      portal_group_id:"",
      portal_id:"",
      portal_domain:"",
    };
  },
  methods: {

    filter: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    signInAgain(){
      this.loginSection = true 
      this.registerbox = false
      console.log(this.loginSection, this.registerbox, "Workinglogin....")
    },
    // closeRegBox() {
    //         this.loginbox = false;
    //         this.$emit('close'); // Emit the 'close' event to the parent component
    //         console.log(this.loginbox, "1111111")
    //     },


    // onClickOutside() {
    //   this.registerbox = false
    // },
    submitForm() {

      console.log(this.valid, 'oooooooooo')
      this.registerReq.user_name = this.personal.firstname + 
      (this.personal.middlename ? " " + this.personal.middlename : '') + 
      (this.personal.lastname ? " " + this.personal.lastname : '');
      this.registerReq.first_name = this.personal.firstname;
      this.registerReq.middle_name = this.personal.middlename;
      this.registerReq.last_name = this.personal.lastname;
      console.log(this.registerReq, 'ffff.....')

      if (this.valid) {
        
        this.loadRegister = true
        this.btnDisabled = true
        
        // this.generateBookingRefId()
        
        console.log(this.personal, 'eeeee......')
        
        this.registerReq.email = this.personal.email;
        this.registerReq.phone_no = this.personal.phonenumber;
        this.registerReq.password = this.personal.password;
        this.registerReq.user_id = this.personal.email;
        this.registerReq.portal_id = this.portal_id;
        this.registerReq.portal_group_id = this.portal_group_id;
        this.registerReq.portal_domain = this.portal_domain;


        axios.post(this.registerUrl, this.registerReq, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(response => {

            if (response.data) {
              this.regForm = false
              this.regMsg = true
              console.log('Response:', response.data);
              console.log('Response-Msg:', response.data.register.message);
              this.registerMsg = response.data.register.message

              // this.registerbox = false
            }
          })


          .catch(error => {
            console.log(error.response.data.message, 'wejjfuoajk')
            alert(`${error.response.data.message}`)
            this.loadRegister = false
            this.btnDisabled = false
          });
      }
    },




    // getRandomChars(length) {
    //         let result = "";
    //         for (let i = 0; i < length; i++) {
    //             const randomIndex = Math.floor(Math.random() * this.strResult.length);
    //             result += this.strResult[randomIndex];
    //         }
    //         console.log(result, "result");
    //         return result;
    //     },
    //     getRandomInt(min, max) {
    //         return Math.floor(Math.random() * (max - min + 1)) + min;
    //     },

    //     generateBookingRefId() {
    //         const randomChars1 = this.getRandomChars(1);
    //         const randomNum = this.getRandomInt(10, 99);
    //         const randomChars2 = this.getRandomChars(1);

    //         this.registerReq.user_id = randomChars1 + randomNum + randomChars2;
    //         console.log(this.registerReq.user_id, 'this.booking_refId ')
    //     },




    closeRegisterBox() {
      this.registerbox = false;
      this.$emit('close'); // Emit the 'close' event to the parent component
      console.log(this.registerbox, '00000')
    },



    getConfig() {
      this.dataloader = false
      // let portalLocal = localStorage.getItem("portalData")
      // let getConfigData1 = JSON.parse(portalLocal)
      const getConfigData1 = getConfigDataFromLocalStorage();
      if (getConfigData1) {
        this.registerUrl = getConfigData1.payload.portal_configuration.API_endpoints.b2cregister
        console.log(this.registerUrl, 'head...reg..1..')
        this.portal_group_id = getConfigData1.payload.portal_configuration.portal_group_id
        this.portal_id = getConfigData1.payload.portal_configuration.portal_id
        this.portal_domain = getConfigData1.payload.portal_configuration.portal_url.replace("https://","");
      }
    },
  },

  created() {
    this.getConfig();
  }
}
</script>



<style scoped>
.main-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* .form-btn {
  padding-left: 40px;
  color: white;
} */

.btn-box {
  background-color: transparent;
  margin: 5px;
  padding: 2px;
  box-shadow: none;
}

.btn-active {
  background-color: blueviolet;
  color: white;
}

>>>.v-input__details {
  display: block !important;
}


/* .v-checkbox .v-input__details {
  display: none;
} */

/* Login Page End */

.register-card{
  width:85%;
}
.form-data{
  width:100%;
}

@media only screen and (max-width: 992px) {

  .form-btn {
    padding: 10px 0px 0px 0px !important;
    /* color: white; */
  }

  .btn-box,
  .pipe {
    color: blueviolet !important;
  }

  .btn-active {
    background-color: blueviolet;
    color: white !important;
  }
}
@media screen and (max-width:480px) {
  .register-card{
    width:80%;
  }
  .form-data{
  width:100%;
  }
}
@media screen and (min-width:480px) and (max-width:992px) {
  .register-card{
    width:80%;
  }
  .form-data{
    width:500px;
    }
}
</style>
